import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/skip';
import 'rxjs/add/operator/takeUntil';
import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import {Action} from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import * as setting from '../actions/setting';
import * as auth from '../actions/authentication';
import {SettingService} from '../services/setting';
import * as routerActions from '../actions/router';
import {Setting} from '../models/setting';
import { ErrorModel } from '../models/error-model';

@Injectable()
export class SettingEffects {

  @Effect()
  loadAllSettings$: Observable<Action> = this.actions$
    .ofType(setting.LOAD_ALL_SETTINGS)
    .map((action: setting.LoadAllSettingsAction) => action.payload)
    .switchMap(pm => {

      const nextLookup$ = this.actions$.ofType(setting.LOAD_ALL_SETTINGS).skip(1);
      const errorMessage = 'Error loading settings.';
      return this.settingService.loadSettings(pm)
        .takeUntil(nextLookup$)
        .map(p => new setting.LoadAllSettingsCompleteAction(p))
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  @Effect()
  saveSetting$: Observable<Action> = this.actions$
    .ofType(setting.SAVE_SETTING)
    .map((action: setting.SaveSettingAction) => action.payload)
    .switchMap(stg => {

      const nextLookup$ = this.actions$.ofType(setting.SAVE_SETTING).skip(1);
      const errorMessage = 'Error saving setting.';
      return this.settingService.setSetting(stg)
        .takeUntil(nextLookup$)
        .map(p => {
          const rtrn = Object.assign({}, stg) as Setting;
          rtrn.id = p;
          return new setting.SaveSettingCompleteAction(rtrn);
        })
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  @Effect()
  saveSettingsComplete$: Observable<Action> = this.actions$
    .ofType(setting.SAVE_SETTING_COMPLETE)
    .map(() => new routerActions.Go({ path: ['admin', 'settings']}));

  @Effect()
  loadSettingById$: Observable<Action> = this.actions$
    .ofType(setting.GET_SETTING_DETAILS)
    .map((action: setting.GetSettingDetailsAction) => action.payload)
    .switchMap(id => {

      const nextLookup$ = this.actions$.ofType(setting.GET_SETTING_DETAILS).skip(1);
      const errorMessage = 'Error loading setting details.';
      return this.settingService.getSetting(id)
        .takeUntil(nextLookup$)
        .map(p => new setting.GetSettingDetailsCompleteAction(p))
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  constructor(private actions$: Actions, private settingService: SettingService) {}
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/effects/setting.ts